import { Routes } from '@angular/router';
import { OrganizacaoGuard } from '@shared/guards/organization.guard';
import { ForceChangePasswordGuard } from '@shared/guards/force-change-password.guard';
import { PropostaAuthGuard } from '@shared/guards/proposta-auth.guard';
import { PropostaStatusGuard } from '@shared/guards/proposta-status.guard';

/**
 * Rotas do módulo de proposta para a jornada offline.
 * Protegida por OrganizacaoGuard + PropostaAuthGuard (redireciona para sign-in com returnUrl).
 */
export const PROPOSTA_ROUTES: Routes = [
  {
    path: ':organizacao/proposta',
    canActivate: [OrganizacaoGuard],
    children: [
      {
        path: ':id/nova-proposta',
        loadComponent: async () =>
          (
            await import(
              './pages/proposta-editar/proposta-editar.page'
            )
          ).PropostaEditarPage,
        canActivate: [PropostaAuthGuard, ForceChangePasswordGuard, PropostaStatusGuard],
      },
      {
        path: ':id/editar',
        redirectTo: ':id/nova-proposta',
        pathMatch: 'full',
      },
    ],
  },
];
